/**
 * Контент справки для страницы дашборда.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'dashboard',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.dashboard.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.dashboard.overview',

  // Идентификатор связанного тура
  tourId: 'dashboard-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'add-widget',
      questionKey: 'help.pages.dashboard.faq.addWidget.question',
      answerKey: 'help.pages.dashboard.faq.addWidget.answer',
    },
    {
      id: 'reorder-widgets',
      questionKey: 'help.pages.dashboard.faq.reorderWidgets.question',
      answerKey: 'help.pages.dashboard.faq.reorderWidgets.answer',
    },
    {
      id: 'resize-widgets',
      questionKey: 'help.pages.dashboard.faq.resizeWidgets.question',
      answerKey: 'help.pages.dashboard.faq.resizeWidgets.answer',
    },
    {
      id: 'remove-widget',
      questionKey: 'help.pages.dashboard.faq.removeWidget.question',
      answerKey: 'help.pages.dashboard.faq.removeWidget.answer',
    },
    {
      id: 'configure-widget',
      questionKey: 'help.pages.dashboard.faq.configureWidget.question',
      answerKey: 'help.pages.dashboard.faq.configureWidget.answer',
    },
    {
      id: 'health-status',
      questionKey: 'help.pages.dashboard.faq.healthStatus.question',
      answerKey: 'help.pages.dashboard.faq.healthStatus.answer',
    },
    {
      id: 'widget-types',
      questionKey: 'help.pages.dashboard.faq.widgetTypes.question',
      answerKey: 'help.pages.dashboard.faq.widgetTypes.answer',
    },
    {
      id: 'drag-drop',
      questionKey: 'help.pages.dashboard.faq.dragDrop.question',
      answerKey: 'help.pages.dashboard.faq.dragDrop.answer',
    },
    {
      id: 'save-layout',
      questionKey: 'help.pages.dashboard.faq.saveLayout.question',
      answerKey: 'help.pages.dashboard.faq.saveLayout.answer',
    },
  ],

  // Секция с описанием виджетов
  widgetsSection: {
    titleKey: 'help.pages.dashboard.widgets.title',
    widgets: [
      {
        id: 'device-stats',
        titleKey: 'help.pages.dashboard.widgets.deviceStats.title',
        descriptionKey: 'help.pages.dashboard.widgets.deviceStats.description',
      },
      {
        id: 'recent-devices',
        titleKey: 'help.pages.dashboard.widgets.recentDevices.title',
        descriptionKey: 'help.pages.dashboard.widgets.recentDevices.description',
      },
      {
        id: 'movement',
        titleKey: 'help.pages.dashboard.widgets.movement.title',
        descriptionKey: 'help.pages.dashboard.widgets.movement.description',
      },
      {
        id: 'daily-mileage',
        titleKey: 'help.pages.dashboard.widgets.dailyMileage.title',
        descriptionKey: 'help.pages.dashboard.widgets.dailyMileage.description',
      },
      {
        id: 'upcoming-maintenance',
        titleKey: 'help.pages.dashboard.widgets.upcomingMaintenance.title',
        descriptionKey: 'help.pages.dashboard.widgets.upcomingMaintenance.description',
      },
      {
        id: 'fuel',
        titleKey: 'help.pages.dashboard.widgets.fuel.title',
        descriptionKey: 'help.pages.dashboard.widgets.fuel.description',
      },
      {
        id: 'speed-violations',
        titleKey: 'help.pages.dashboard.widgets.speedViolations.title',
        descriptionKey: 'help.pages.dashboard.widgets.speedViolations.description',
      },
      {
        id: 'engine-hours',
        titleKey: 'help.pages.dashboard.widgets.engineHours.title',
        descriptionKey: 'help.pages.dashboard.widgets.engineHours.description',
      },
      {
        id: 'inactive-devices',
        titleKey: 'help.pages.dashboard.widgets.inactiveDevices.title',
        descriptionKey: 'help.pages.dashboard.widgets.inactiveDevices.description',
      },
      {
        id: 'scheduled-reports',
        titleKey: 'help.pages.dashboard.widgets.scheduledReports.title',
        descriptionKey: 'help.pages.dashboard.widgets.scheduledReports.description',
      },
      {
        id: 'geozone-activity',
        titleKey: 'help.pages.dashboard.widgets.geozoneActivity.title',
        descriptionKey: 'help.pages.dashboard.widgets.geozoneActivity.description',
      },
    ],
  },

  // Контекстные подсказки для элементов страницы
  tooltips: {
    editMode: 'help.tooltips.dashboard.editMode',
    addWidget: 'help.tooltips.dashboard.addWidget',
    widgetSettings: 'help.tooltips.dashboard.widgetSettings',
    healthStatus: 'help.tooltips.dashboard.healthStatus',
  },

  // Связанные туры
  relatedTours: ['onboarding', 'devices-page'],
}
